import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShanghaimetroComponent } from './simple-icons-shanghaimetro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShanghaimetroComponent ],
    exports:      [ SimpleIconsShanghaimetroComponent ],
    bootstrap:    []
})
export class SimpleIconsShanghaimetroModule {}
